<template>
    <div>
        <CuentaAtras @tiempoTerminado="borrarSesion()"/>
        <PageTitle :title="$t('perfil_invitaciones.generar_invitaciones')" sectionClass="strech"/>
        <section class="padding-vertical-content">
            <b-container>
                <Stepper
                    ref="stepper"
                    :steps="steps" 
                >
                    <template #pasoZona="{ changeStep }">
                        <ContentOrLoading>
                            <PasoUnoInvitaciones
                                v-if="evento"
                                :key="reloadComponents"
                                :event_id="event_id"
                                :sesion_id="sesion_id"
                                :abono_id="abono_id"
                                :place="evento?.place"
                                :frontend="true"
                                @terminado="zona => { finalizarPasoUno(zona); changeStep(); }"
                            />
                        </ContentOrLoading>
                    </template>
                    <template #pasoButacas="{ changeStep }">
                        <PasoDosInvitaciones
                            :key="reloadComponents"
                            :zona="zona"
                            :event_id="event_id"
                            :sesion_id="sesion_id"
                            :abono_id="abono_id"
                            :max_asientos="max_asientos"
                            @setSessionId="(sessionId, seats) => { session_id = sessionId; asientos = seats; changeStep() }"
                            @cambiarZona="() => { cambiarZona(); changeStep(true); }"
                            :frontend="true"
                        />
                    </template>
                    <template #pasoDatos="{ changeStep }">
                        <PasoTresInvitaciones
                            :key="reloadComponents"
                            :zona="zona"
                            :evento="evento"
                            :sesion_id="sesion_id"
                            :session_id="session_id"
                            :abonado="abonado"
                            :asientos="asientos"
                            :desactivar="loading"
                            @borrarSesionAndCambiarPaso="borrarSesionAndCambiarPaso()"
                            @guardarDatos="(payload, datos_abonado) => { guardarDatos(payload, datos_abonado); changeStep() }"
                        />
                    </template>
                    <template #pasoResumen="{ changeStep }">
                        <PasoCuatroInvitaciones
                            :key="reloadComponents"
                            :session_id="session_id"
                            :asientos="asientos"
                            :desactivar="loading"
                            :datos_pago="datosPago"
                            :frontend="true"
                            @terminado="(precio_cero) => { procesarCompra(precio_cero); }"
                            @volver="() => { changeStep(true) }"
                        />
                    </template>
                    <template #pasoPago>
                        <b-container id="pago">
                            <b-row>
                                <b-col cols="12">
                                    <h2 class="m-0 h1 text-uppercase">
                                        {{ $t('compra.confirmacion_compra') }}
                                    </h2>
                                    <div class="subtitle h3 light mb-3 mb-lg-5">
                                        {{ $t('compra.introduce_datos') }}
                                    </div>
                                    <PagoPaycometComponent
                                        ref="pago"
                                        tipo_venta="evento"
                                        :jet_id="datosPago.jet_id"
                                        :session_id="session_id"
                                    />		
                                </b-col>
                            </b-row>
                        </b-container>
                    </template>
                </Stepper>
            </b-container>
        </section>
    </div>
</template>

<script>
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import CuentaAtras from '@/components/frontend/events/compra/CuentaAtras';
    import Stepper from '@/components/frontend/events/compra/components/Stepper';
    import PasoUnoInvitaciones from '@/components/frontend/perfil/invitaciones/PasoUnoInvitaciones';
    import PasoDosInvitaciones from '@/components/frontend/perfil/invitaciones/PasoDosInvitaciones';
    import PasoTresInvitaciones from '@/components/frontend/perfil/invitaciones/PasoTresInvitaciones';
    import PasoCuatroInvitaciones from '@/components/frontend/perfil/invitaciones/PasoCuatroInvitaciones';
    import PagoPaycometComponent from '@/components/frontend/compra/components/PagoPaycometComponent.vue';
    
    export default {
        props: {
            event_id: [String, Number],
            sesion_id: [String, Number],
            abono_id: [String, Number]
        },
        data() {
            return {
                loading: false,
                evento: null,
                invitaciones_abonado: null,
                reloadComponents: 1,
                session_id: null,
                asientos: [],
                datosPago: {},
                steps: [
                    { label: this.$t('perfil_invitaciones.zona'), slot: 'pasoZona' },
                    { label: this.$t('perfil_invitaciones.butacas'), slot: 'pasoButacas' },
                    { label: this.$t('perfil_invitaciones.rellenar_datos'), slot: 'pasoDatos' },
                    { label: this.$t('partido.resumen_compra'), slot: 'pasoResumen' }
                ]
            }
        },
        watch: {
            datosPago(newVal) {
                if (newVal.jet_id) {
                    const existe = this.steps.find(step => step.slot === 'pasoPago');
                    if (!existe) {
                        this.steps.push({ label: this.$t('carrito.pago'), slot: 'pasoPago' });
                    }
                }
            }
        },
        computed : {
            teatro() {
                return this.$store.getters.getTeatro;
            },
            max_asientos() {
                return Math.min(
                    this.evento?.invitaciones_restantes || 0, 
                    this.abonado?.invitaciones_abonado?.n_total_disponibles || 0
                );
            }
        },
        methods: {
            getEvento() {
                this.loading = true;

                const params = {
                    filters: {
                        evento_id: this.event_id
                    },
                    abonado_id: this.abono_id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.perfil.invitaciones.abonados.eventos'), params).then(res => {
                    this.evento = res.data.data[0];

                    if (this.evento.invitaciones_restantes === 0) {
                        this.$router.push({name: 'invitaciones', params: { abono_id: this.abono_id }});
                        this.$toast.error('Ha consumido todas las invitaciones disponibles para este evento');
                    }
                }).finally(() => {
                    this.loading = false;
                })
            },
            getAbonado() {
                this.$store.dispatch(this.config.getVuexAlias('front.perfil.invitaciones.abonados'), { abonado_id: this.abono_id }).then(res => {
                    this.abonado = res.data.data;

                    if (this.abonado.email) {
                        this.abonado.email_confirmation = this.abonado.email;
                    }

                    if (!this.abonado.tipoDocumentoSeleccionado) {
                        this.abonado.tipoDocumentoSeleccionado = this.detectarTipoDocumento(this.abonado.dni.trim().toUpperCase())
                    }
                });
            },
            finalizarPasoUno(zona) {
                this.zona = zona;
            },
            guardarDatos(payload, datos_abonado) {
                this.loading = true;
                this.abonado = { ...datos_abonado };
                
                this.$store.dispatch(this.config.getVuexAlias('front.perfil.invitaciones.guardar-datos'), payload).then(res => {
                    this.datosPago = {
                        amount: res.data.data?.amount,
                        jet_id: res.data?.jet_id,
                        formulario: res.data?.formulario
                    }
                }).catch(error => {
                    this.$toast.error(error?.response?.data?.message);
                }).finally(() => {
                    this.loading = false;
                });
            },
            procesarCompra(precio_cero) {
                this.loading = true;

                if (precio_cero) {
                    this.procesarCompraPrecioCero();
                } else {
                    this.$refs.stepper.changeStep();
                    setTimeout(() => {
                        this.loading = false;
                        this.$nextTick(() => {
                            this.$scrollTo('#pago', 100);
                        });
                    }, 2000);
                }
            },
            procesarCompraPrecioCero() {
                const params = {
                    filters: {},
                    abonado_id: this.abono_id,
                    evento_id: this.event_id,
                    sesion_id: this.sesion_id,
                    session_id: this.session_id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.perfil.invitaciones.procesar-compra-sin-gg'), params).then(res => {
                    this.$router.push(`/compra/${this.session_id}/${res.data.n_pedido}`);
                }).finally(() => this.loading = false);
            },
            cambiarZona() {
                this.zona = null;
                this.reloadComponents++;
            },
            borrarSesion() {
                this.$router.push({ name: 'invitaciones' });
            },
            borrarSesionAndCambiarPaso() {
                if (this.session_id) {
                    this.$store.dispatch(this.config.getVuexAlias('front.sesion.delete'), { session_id: this.session_id }).finally(() => {
                        this.asientos = [];
                        this.session_id = null;
                        this.$refs.stepper.currentStep--;
                    });
                }
            },
            detectarTipoDocumento(valor) {
                if (/^[XYZ]\d{7}[A-Z]$/.test(valor)) {
                    return { type: "NIE", value: "" };
                }

                if (/^\d{8}[A-Z]$/.test(valor)) {
                    return { type: "DNI", value: "" };
                }

                if (/^[A-HJ-NP-SUVW]\d{7}[0-9A-J]$/.test(valor)) {
                    return { type: "NIF", value: "" };
                }

                return { type: "PASAPORTE", value: "" };
            },
        },
        created() {
            if (!this.teatro.invitaciones_para_abonados) {
                this.$router.go(-1);
            } else {
                this.getEvento();
                this.getAbonado();
            }
        },
        components: {
            PageTitle,
            CuentaAtras,
            Stepper,
            PasoUnoInvitaciones,
            PasoDosInvitaciones,
            PasoTresInvitaciones,
            PasoCuatroInvitaciones,
            PagoPaycometComponent
        }
    }
</script>
